import { EyeInvisibleOutlined, EyeOutlined, LoadingOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useMessageError } from '../../../../hooks/common';
import { InternationalResponse, useInternationalUpdate } from '../../../../hooks/api/internationals';

import styles from './index.module.scss';

export interface ButtonEyeProps {
  international: InternationalResponse;
  onChange: () => void;
  loading?: boolean;
}

export default function ButtonEye({ international, onChange, loading }: ButtonEyeProps) {
  const internationalUpdate = useInternationalUpdate(international.id);

  useEffect(() => {
    if (!internationalUpdate.error && !internationalUpdate.loading && internationalUpdate.data) {
      onChange();
    }
  }, [internationalUpdate.data]);

  useMessageError([internationalUpdate]);

  useEffect(() => {
    if (!loading) {
      internationalUpdate.clearResponse();
    }
  }, [loading]);

  if (internationalUpdate.loading || (loading && internationalUpdate.data)) {
    return (
      <Spin
        indicator={<LoadingOutlined spin />}
        style={{ padding: 6 }}
      />
    );
  }

  return !international.isActive ? (
    <EyeInvisibleOutlined
      title="click and show"
      className={styles.icon}
      onClick={(e) => {
        e.preventDefault();
        internationalUpdate.fetch({
          isActive: true,
        });
      }}
      size={20}
    />
  ) : (
    <EyeOutlined
      title="click and hide"
      className={styles.icon}
      onClick={(e) => {
        e.preventDefault();
        internationalUpdate.fetch({
          isActive: false,
        });
      }}
      size={20}
    />
  );
}
